import { render, staticRenderFns } from "./EtfTable.vue?vue&type=template&id=0cb2de38&scoped=true"
import script from "./EtfTable.vue?vue&type=script&lang=js"
export * from "./EtfTable.vue?vue&type=script&lang=js"
import style0 from "./EtfTable.vue?vue&type=style&index=0&id=0cb2de38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb2de38",
  null
  
)

export default component.exports